import { Component, OnInit, OnDestroy, Input, EventEmitter, ViewChild, TemplateRef } from '@angular/core';

import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Columns, Config, DefaultConfig, API, APIDefinition } from 'ngx-easy-table';
import { IntranetoldService } from '../../../api/intranetold.service'
import { variableGlobal } from "../../../global.enum";
import { abreTablaGenericoComponent } from '../../app/query-mongo/abreTablaGenerico';


@Component({
  selector: 'app-detalleArticuloPedidoInterno',
  templateUrl: './detalleArticuloPedidoInterno.html',
  styleUrls: ['./stock-comercial.component.sass']
})

export class StockComercialDPedidoInternoComponent implements OnInit {
  @Input() anyDataForm: any;
  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private _api: IntranetoldService,
  ) {
  }
  @ViewChild('tableModal', { static: true }) tableModal: APIDefinition;
  @ViewChild('frmIsCommited', { static: true }) frmIsCommited: TemplateRef<any>;
  @ViewChild('frmOnOrder', { static: true }) frmOnOrder: TemplateRef<any>;
  @ViewChild('frmDetalleLote', { static: true }) frmDetalleLote: TemplateRef<any>;
  @ViewChild('frmDocDate', { static: true }) frmDocDate: TemplateRef<any>;
  @ViewChild('frmDocDueDate', { static: true }) frmDocDueDate: TemplateRef<any>;
  @ViewChild('frmDocTotal', { static: true }) frmDocTotal: TemplateRef<any>;

  ItemCode: string;
  dataModal: any = [];
  public configurationModal: Config;
  public columnsModal: Columns[];
  ngOnInit(): void {
    this.cargaTabla();
  }

  async cargaTabla() {
    this.columnsModal = [
      { key: 'DocNum', title: "N° Documento" },
      { key: 'CardCode', title: 'Código Cliente' },
      { key: 'CardName', title: 'Nombre Cliente' },
      { key: 'Quantity', title: 'Cantidad' },
      { key: 'DocDate', title: 'Fecha Creación', cellTemplate: this.frmDocDate },
      { key: 'DocDueDate', title: 'Fecha Límite', cellTemplate: this.frmDocDueDate },
      { key: 'DocTotal', title: 'Total Cotización', cellTemplate: this.frmDocTotal },
      { key: 'DocCurrency', title: 'Moneda' },
      { key: 'DocStatus', title: 'Estado' },
      { key: 'DocRate', title: 'Tasa Cambio' },
      { key: 'Comments', title: 'Comentarios' }
    ];

    this.configurationModal = {
      ...DefaultConfig,
      //searchEnabled: true,
      detailsTemplate: true,
      //paginationRangeEnabled: false,

      horizontalScroll: true,
      resizeColumn: false,
      fixedColumnWidth: true,
    };


    var data: any = await this._api.getQueryAll();
    var query: string = "";
    await data.objeto.forEach(element => {
      if (element.NOMBRE == "stockComercialDetallePedidoInterno") {
        query = element.CONSULTA;
      }
    });

    query = query.replace('{ITEMCODE}',"'" +this.ItemCode +"'");

    this.dataModal = await this._api.GetNotFileQuery(query);
    
    this.dataModal = this.dataModal.objeto;


    if (variableGlobal.ESTILO_EASY_TABLE) {
      this.setClass(variableGlobal.ESTILO_EASY_TABLE);
    }
  }
  private setClass(name: string): void {
    this.tableModal.apiEvent({
      type: API.setTableClass,
      value: name,
    });
  }
  cerrar() {
    this.activeModal.close();
  }

  async abrirItemLote(item) {

    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: "xl",
      modalDialogClass: variableGlobal.CLASS_MODAL_BG
    };

    var queryConsulta: string;
    queryConsulta = await this.obtieneQueryMongo("VistaLotesBodega");

    queryConsulta = queryConsulta.replace("INPUTARTICULO", item.ItemCode);
    queryConsulta = queryConsulta.replace("INPUTBODEGA", item.WhsCode);

    const modalRef = this.modalService.open(abreTablaGenericoComponent, ngbModalOptions);
    modalRef.componentInstance.query = queryConsulta;
    modalRef.componentInstance.titulo = "Detalle lotes de articulo";
    modalRef.result.then();

  }
  async abrirItemDetalle(item) {

    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: "xl",
      modalDialogClass: variableGlobal.CLASS_MODAL_BG
    };

    var queryConsulta: string;
    queryConsulta = await this.obtieneQueryMongo("DocumentosVentaArticulo");

    queryConsulta = queryConsulta.replace("INPUTARTICULO", item.ItemCode);
    queryConsulta = queryConsulta.replace("INPUTBODEGA", item.WhsCode);

    const modalRef = this.modalService.open(abreTablaGenericoComponent, ngbModalOptions);
    modalRef.componentInstance.query = queryConsulta;
    modalRef.componentInstance.titulo = "Detalle ventas de articulo";
    modalRef.result.then();

  }

  async abrirItemDetalleCompra(item) {

    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: "xl",
      modalDialogClass: variableGlobal.CLASS_MODAL_BG
    };

    var queryConsulta: string;
    queryConsulta = await this.obtieneQueryMongo("DocumentosCompraArticulo");

    queryConsulta = queryConsulta.replace("INPUTARTICULO", item.ItemCode);
    queryConsulta = queryConsulta.replace("INPUTBODEGA", item.WhsCode);

    const modalRef = this.modalService.open(abreTablaGenericoComponent, ngbModalOptions);
    modalRef.componentInstance.query = queryConsulta;
    modalRef.componentInstance.titulo = "Detalle ventas de articulo";
    modalRef.result.then();

  }

  async obtieneQueryMongo(nombre) {
    var data: any = await this._api.getQueryAll();
    var query: string = "";
    await data.objeto.forEach(element => {
      if (element.NOMBRE == nombre) {
        query = element.CONSULTA;
      }
    });

    return query;
  }


}
